import React from 'react';
import { Container } from './styles';

interface BulletinSelectedItemLabelProps {
  selectedBiddings: Array<number>;
  selectedFollowups: Array<number>;
  setSelectedBiddings: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectedFollowups: React.Dispatch<React.SetStateAction<number[]>>;
}

const BulletinSelectedItemLabel = (props: BulletinSelectedItemLabelProps) => {
  const { selectedBiddings, selectedFollowups, setSelectedBiddings, setSelectedFollowups } = props;

  if (selectedBiddings.length === 0 && selectedFollowups.length === 0) return <div />;

  return (
    <Container className="ml-3">
      {selectedBiddings.length > 0 && (
        <>
          {selectedBiddings.length} {selectedBiddings?.length === 1 ? 'licitação' : 'licitações'}
        </>
      )}{' '}
      {selectedBiddings.length > 0 && selectedFollowups.length > 0 && 'e'}{' '}
      {selectedFollowups.length > 0 && (
        <>
          {selectedFollowups.length}{' '}
          {selectedFollowups?.length === 1 ? 'acompanhamento' : 'acompanhamentos'}
        </>
      )}{' '}
      {selectedBiddings.length + selectedFollowups.length > 1
        ? `selecionad${selectedBiddings.length > 0 && selectedFollowups.length === 0 ? 'a' : 'o'}s.`
        : `selecionad${
            selectedBiddings.length > 0 && selectedFollowups.length === 0 ? 'a' : 'o'
          }.`}{' '}
      <button
        type="button"
        className="btn btn-link m-0 py-0 px-1 border-0"
        onClick={() => {
          setSelectedBiddings([]);
          setSelectedFollowups([]);
        }}
      >
        Limpar seleção.
      </button>
    </Container>
  );
};

export default BulletinSelectedItemLabel;
